import React, { Component } from 'react'
import CreatingComponent from '../CreatingComponent'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'

import LanguagesForm from './Steps/MainInfo/LanguagesForm'
import CategoryForm from './Steps/MainInfo/CategoryForm'
import TitleTags from './Steps/MainInfo/TitleTags'
import DescriptionForm from './Steps/MainInfo/DescriptionForm'
import PhotosForm from './Steps/MainInfo/PhotosForm'
import WhatWillDo from './Steps/MoreDetails/WhatWillDo'
import WhereWillBe from './Steps/MoreDetails/WhereWillBe'
import WhatYouProvide from './Steps/MoreDetails/WhatYouProvide'
import NeedToBring from './Steps/MoreDetails/NeedToBring'
import AddInfo from './Steps/MoreDetails/AddInfo'
import MeetingPoint from './Steps/TimesLocation/MeetingPoint'
import LengthPrice from './Steps/TimesLocation/LengthPrice'
import EventDates from './Steps/TimesLocation/EventDates'
import BookingNotice from './Steps/TimesLocation/BookingNotice'
import ActivitySummary from './ActivitySummary'
import FinishPage from './Steps/FinishPage'
import _ from 'lodash'

import LOCAL_TOUR from '../../graphql/Activity/LocalTour.graphql'
import { getActivitySteps } from '../../constants'

class ActivitySteps extends Component {
  state = { isActivityLoaded: false, routes: {} }

  componentDidMount() {
    const { match, history } = this.props

    if (match.params.id && match.params.step) {
      history.push(`/activity-steps/${match.params.id}/title-tags`)
    } else if (match.params.id && !match.params.step && match.params.id !== 'title-tags') {
      history.push(`/activity-steps/${match.params.id}/title-tags`)
    } else {
      history.push(`/activity-steps/title-tags`)
    }
  }

  componentWillReceiveProps(nextProps) {
    const localTour = _.head(nextProps.data.allLocalTours)

    if (this.props.loading && !nextProps.loading && !nextProps.user) {
      this.props.history.push('/')
    } else if (localTour && !this.state.isActivityLoaded) {
      this.updateLocalState(localTour)
    }
  }

  updateLocalState = localTour => {
    this.setState(
      {
        ...localTour,
        tags: localTour.tags.map(tag => {
          return {
            value: tag.value
          }
        }),
        photos: localTour.photos.map(photo => {
          return {
            id: photo.id,
            src: photo.url
          }
        }),
        meetingPoint: localTour.meetingPoint,
        isActivityLoaded: true
      },
      this.validateSteps
    )
  }

  updateSteps = () =>
    this.props.data
      .refetch()
      .then(res => _.head(_.get(res, 'data.allLocalTours', [])) && this.updateLocalState(_.head(_.get(res, 'data.allLocalTours', []))))

  containers = [
    {
      path: '/activity-steps/languages',
      component: () => <LanguagesForm currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/languages',
      component: () => <LanguagesForm currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/category',
      component: () => <CategoryForm currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/category',
      component: () => <CategoryForm currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/title-tags',
      component: () => <TitleTags currentSteps={this.state} data={this.props.data} updateSteps={() => this.updateSteps()} />
    },
    {
      path: '/activity-steps/title-tags',
      component: () => (
        <TitleTags currentSteps={this.state} data={this.props.data} user={this.props.user} updateSteps={() => this.updateSteps()} />
      )
    },
    {
      path: '/activity-steps/description',
      component: () => (
        <DescriptionForm currentSteps={this.state} data={this.props.data} user={this.props.user} updateSteps={this.updateSteps} />
      )
    },
    {
      path: '/activity-steps/:id/description',
      component: () => <DescriptionForm currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/photos',
      component: () => <PhotosForm currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/photos',
      component: () => <PhotosForm currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/what-will-do',
      component: () => <WhatWillDo currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/what-will-do',
      component: () => <WhatWillDo currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/where-will-be',
      component: () => <WhereWillBe currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/where-will-be',
      component: () => <WhereWillBe currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/what-you-provide',
      component: () => <WhatYouProvide currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/what-you-provide',
      component: () => <WhatYouProvide currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/need-to-bring',
      component: () => <NeedToBring currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/need-to-bring',
      component: () => <NeedToBring currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/add-info',
      component: () => <AddInfo currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/add-info',
      component: () => <AddInfo currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/meeting-point',
      component: () => <MeetingPoint currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/meeting-point',
      component: () => <MeetingPoint currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/length-price',
      component: () => <LengthPrice currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/length-price',
      component: () => <LengthPrice currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/event-dates',
      component: () => <EventDates currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/event-dates',
      component: () => <EventDates currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/booking-notice',
      component: () => <BookingNotice currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    {
      path: '/activity-steps/:id/booking-notice',
      component: () => <BookingNotice currentSteps={this.state} data={this.props.data} updateSteps={this.updateSteps} />
    },
    { path: '/activity-steps/:id/finish', component: () => <FinishPage summary={this.state} /> },
    { path: '/activity-steps/finish', component: () => <FinishPage summary={this.state} data={this.props.data} /> }
  ]

  fillValidateArray = (tour, toValidate = []) => {
    toValidate.push(!!tour.title && !!_.get(tour, 'tags', []).length && !!tour.tourLocation)
    toValidate.push(!!_.get(tour, 'languages', []).length)
    toValidate.push(!!_.get(tour, 'categories', []).length)
    toValidate.push(!!_.get(tour, 'shortDescription', false))
    toValidate.push(!!_.get(tour, 'photos', []).length)
    toValidate.push(!!_.get(tour, 'whatWeDo', false))
    toValidate.push(!!_.get(tour, 'whereWeBe', false))
    toValidate.push(!!_.get(tour, 'whatWeProvide', false))
    toValidate.push(!!_.get(tour, 'whatYouBring', false))
    toValidate.push(!!tour.securityNotice && !!tour.weatherNotice)
    toValidate.push(!!_.get(tour, 'meetingPoint', false))
    toValidate.push(
      !!tour.maxGroupSize && !!tour.minGroupSize && !!tour.notifyBefore && !!tour.groupPrice && !!tour.currency && !!tour.privateTourPrice
    )
    toValidate.push(!!_.get(tour, 'tourDates', []).length)
    return toValidate
  }

  validateSteps = () => {
    let routes = {}
    const toValidate = this.fillValidateArray(this.state)
    toValidate.forEach((item, index) => {
      if (item) {
        routes = { ...routes, [`${index}`]: true }
      }
    })
    this.setState({ routes })
  }

  render() {
    const pathElements = this.props.location.pathname.split('/')
    const route = pathElements[pathElements.length - 1]
    return (
      <div>
        <CreatingComponent
          getNavSteps={() => getActivitySteps(this.props.t)}
          containers={this.containers}
          routes={this.state.routes}
          contentContainerClassName="col-md-8"
        >
          <div className="summary-wrapper" style={{ right: 0 }}>
            {route !== 'finish' && <ActivitySummary summary={this.state} extraClass="" updateState={() => this.props.data.refetch()} />}
          </div>
        </CreatingComponent>
      </div>
    )
  }
}

export default compose(
  translate('activity_steps'),
  graphql(LOCAL_TOUR, {
    options: props => ({
      variables: {
        id: props.match.params.id
      }
    })
  })
)(ActivitySteps)



// WEBPACK FOOTER //
// src/components/ActivitySteps/index.js